export default {"src":"/_next/static/media/flag-cn.a2bd0698.svg","height":11,"width":16,"blurWidth":0,"blurHeight":0};